import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/api";

/**
 * ログインユーザーのロール判定を一本化するフック。
 *
 * **UXガード専用**。表示/非表示の切り替えやボタンの活性・非活性など、
 * クライアント側の見た目の制御にのみ使うこと。
 * 認可の正はあくまでバックエンド（requireAuth / requirePlatformAdmin 等の
 * ミドルウェア）にあり、このフックの結果を根拠にAPI呼び出しを省略したり
 * サーバー側チェックを緩めたりしてはならない。
 *
 * queryKey ["auth-me"] は既存の useCanWrite や各画面の inline auth-me query と
 * 共有される（同一キャッシュを参照するための前提）。queryKey / options を
 * 変更しないこと。
 */
export function useRole() {
  const {
    data: me,
    isLoading,
    isError,
    isRefetchError,
    error,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["auth-me"],
    queryFn: () => authApi.me(),
  });

  const role = me?.user.role;
  const canWrite = me != null && role !== "viewer" && role !== "advertiser_viewer";
  const isViewer = role === "viewer";
  const isAdvertiserViewer = role === "advertiser_viewer";
  const isAdmin = role === "admin" || role === "platform_admin";
  const isPlatformAdmin = role === "platform_admin";
  const dmEnabled = me?.tenant?.dmSendEnabled === true;
  const dmReplyIntakeEnabled = me?.tenant?.dmReplyIntakeEnabled === true;

  return {
    me,
    role,
    isLoading,
    isError,
    isRefetchError,
    error,
    isFetching,
    refetch,
    isViewer,
    isAdvertiserViewer,
    isAdmin,
    isPlatformAdmin,
    canWrite,
    dmEnabled,
    dmReplyIntakeEnabled,
  };
}
